import { createFileRoute } from '@tanstack/react-router';
import CompanyNewDocumentRequest from '@/modules/document-requests/pages/company-new-document-request';

export const Route = createFileRoute(
  '/_authenticated/_system/_company/my-document-requests/new',
)({
  head: () => ({
    meta: [{ title: 'Nova Solicitação de Documento' }],
  }),
  component: CompanyNewDocumentRequest,
});
